export default "__VITE_ASSET__99e64a66__"